import { ApplicationUsageSummaryComponent } from "./application-usage-summary/application-usage-summary.component";
import { ChartComponent } from "ng-apexcharts";
import { ChartCostsPerDayComponent } from "./chart-costs-per-day/chart-costs-per-day.component";
import { ChartMdmDeviceEndOfLifeYearCountComponent } from "./chart-mdm-device-end-of-life-year-count/chart-mdm-device-end-of-life-year-count.component";
import { ChartMdmDeviceVolumeAndHealthTrendComponent } from "./chart-mdm-device-volume-and-health-trend/chart-mdm-device-volume-and-health-trend.component";
import { ChartSimNotInactivePerDayComponent } from 'src/app/shared/widget-no-formsmodalmodule/chart-sim-not-inactive-per-day/chart-sim-not-inactive-per-day.component';
import { ChartTodaysUsageComponent } from "./chart-todays-usage/chart-todays-usage.component";
import { ChartUsagePerDayComponent } from "./chart-usage-per-day/chart-usage-per-day.component";
import { CommonModule } from "@angular/common";
import { CountryDetailsComponent } from "./country-details/country-details.component";
import { CountryUsageSummaryComponent } from "./country-usage-summary/country-usage-summary.component";
//import { CountUpModule } from 'ngx-countup'; //CRN_20261013 - Retired
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { defineElement } from "@lordicon/element";
import { DropdownsModule } from 'src/app/core/dropdowns/dropdowns.module';
import { FormsModalConfirmationModule } from 'src/app/forms-modal-confirmation/forms-modal-confirmation.module';
import { FormsModule } from '@angular/forms';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import lottie from 'lottie-web';
import { MapSimLocationsModule } from "./map-sim-locations/map-sim-locations.module";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared.module";
//import { StatComponent } from './stat/stat.component'; //CRN_20261013 - Retired

@NgModule({
  declarations: [
    ApplicationUsageSummaryComponent,
    ChartCostsPerDayComponent,
    ChartMdmDeviceEndOfLifeYearCountComponent,
    ChartMdmDeviceVolumeAndHealthTrendComponent,
    ChartSimNotInactivePerDayComponent,
    ChartTodaysUsageComponent,
    ChartUsagePerDayComponent,
    CountryDetailsComponent,
    CountryUsageSummaryComponent
    //StatComponent //CRN_20261013 - Retired
  ],
  imports: [
    ChartComponent,
    CommonModule,
    //CountUpModule, //CRN_20261013 - Retired
    DropdownsModule,
    FormsModalConfirmationModule,
    FormsModule,
    LeafletModule,
    MapSimLocationsModule,
    RouterModule,
    SharedModule
  ],
  exports: [
    ApplicationUsageSummaryComponent,
    ChartCostsPerDayComponent,
    ChartMdmDeviceEndOfLifeYearCountComponent,
    ChartMdmDeviceVolumeAndHealthTrendComponent,
    ChartSimNotInactivePerDayComponent,
    ChartTodaysUsageComponent,
    ChartUsagePerDayComponent,
    CountryDetailsComponent,
    CountryUsageSummaryComponent,
    MapSimLocationsModule
    //StatComponent, //CRN_20261013 - Retired
  ],
    schemas: [
      CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class Widget_NoFormsModalModule_Module {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
